import React from 'react';
import { Grid } from '@elliemae/ds-grid';
import { Checkmark } from '@elliemae/ds-icons';
import { useGetGlobalAttributes } from '@elliemae/ds-props-helpers';
import { StyledContainer, StyledTitle } from './style.js';
interface MobileListSingleItemT {
  title: string;
  value: string;
  isSelected: boolean;
}
export const MobileListSingleItem: React.ComponentType<MobileListSingleItemT> = (props) => {
  const { title, isSelected } = props;
  const globalsAttrs = useGetGlobalAttributes(props);
  return (
    <StyledContainer
      cols={['16px', 'auto']}
      height="40px"
      width="100%"
      pl="16px"
      pr="16px"
      gutter="xs"
      {...globalsAttrs}
    >
      <Grid alignItems="center">{isSelected && <Checkmark color={['brand-primary', '600']} />}</Grid>
      <Grid alignItems="center">
        <StyledTitle>{title}</StyledTitle>
      </Grid>
    </StyledContainer>
  );
};
